export const moduleName = 'axp-travel-advisory';
